import "./style.scss";
import { FC, useEffect, useState } from "react";
import backForDocMalta from "@/src/assets/admissionOfficePage/back-for-doc-malta.webp";
import backForDocPoland from "@/src/assets/admissionOfficePage/back-for-doc-poland.webp";
import backForDocUkraine from "@/src/assets/admissionOfficePage/back-for-doc-ukraine.webp";
import { useSelector } from "react-redux";
import { RootState } from "@/src/store";
import { AOPUkrainePaymentConfirmationData } from "@/src/types/admissionOffice";

interface AOPPrevProps {
  bodyForPrev: AOPUkrainePaymentConfirmationData;
  isPrevReady: boolean;
}

const AOPPrev: FC<AOPPrevProps> = ({ bodyForPrev, isPrevReady }) => {
  const [actualBg, setActualBg] = useState(backForDocMalta);
  const [actualCountryDoc, setActualCountryDoc] = useState("malta");
  const currentTab = useSelector((state: RootState) => state.admissionOfficeDoc.tabsAdmissionsOffice);

  useEffect(() => {
    switch (currentTab) {
      case "poland":
        setActualBg(backForDocPoland);
        setActualCountryDoc("poland");
        break;
      case "ukraine":
        setActualBg(backForDocUkraine);
        setActualCountryDoc("ukraine");
        break;
      default:
        setActualBg(backForDocMalta);
        setActualCountryDoc("malta");
        break;
    }
  }, [currentTab]);

  return (
    <div className="admission-office-prev-wrapper">
      <div className={`admission-office-prev ${actualCountryDoc} payment`}>
        <img className="admission-office-prev-background" src={actualBg} alt={`${actualBg}`} />
        <div className="admission-office-prev-section title">
          <p>Payment confirmation letter</p>
        </div>
        <div className="admission-office-prev-section number-and-date">
          <span>Date: {bodyForPrev.currentDate ? bodyForPrev.currentDate : "-"}</span>
          <span>№ -</span>
        </div>
        {bodyForPrev.payment_header ? (
          <div className="admission-office-prev-section body-content header">
            {bodyForPrev.payment_header?.map((item, idx) => (
              <div key={idx} dangerouslySetInnerHTML={{ __html: item }} />
            ))}
          </div>
        ) : null}
        <div className={`admission-office-prev-section info ${isPrevReady ? "preview" : ""}`}>
          <p>Full Name: {bodyForPrev.fullName ? bodyForPrev.fullName : ""}</p>
          <p>Data of Birth: {bodyForPrev.dateOfBirth ? bodyForPrev.dateOfBirth : ""}</p>
          <p>Nationality: {bodyForPrev.nationality ? bodyForPrev.nationality : ""}</p>
          <p>Course: {bodyForPrev.course ? bodyForPrev.course : ""}</p>
          <p>Medium of Instruction: {bodyForPrev.mediumOfInstruction ? bodyForPrev.mediumOfInstruction : ""}</p>
          <p>Duration: {bodyForPrev.duration ? bodyForPrev.duration : ""}</p>
        </div>
        <div className="admission-office-prev-section signature">
          <p>Head of Foreign Students department</p>
          <p>Fedorova Anzhelika</p>
          <p>International European University</p>
        </div>
        {bodyForPrev.payment_footer ? (
          <div className="admission-office-prev-section body-content footer">
            {bodyForPrev.payment_footer?.map((item, idx) => (
              <div key={idx} dangerouslySetInnerHTML={{ __html: item }} />
            ))}
          </div>
        ) : null}
      </div>
    </div>
  );
};

export default AOPPrev;
